var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorybook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88.1 111",
    style: {
      enableBackground: "new 0 0 88.1 111"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF4785;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{mask:url(#mask-2_1_);fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    className: "st0",
    d: "M3.2,98.9L0,14.3C-0.1,11.5,2,9.2,4.8,9l71.9-4.5c2.8-0.2,5.3,2,5.5,4.8c0,0.1,0,0.2,0,0.3 v92.1c0,2.8-2.3,5.1-5.1,5.1c-0.1,0-0.2,0-0.2,0l-68.7-3.1C5.4,103.7,3.3,101.5,3.2,98.9L3.2,98.9z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 21.2,
    y: 4.5,
    width: 50.3,
    height: 83
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 21.2,
    y: 4.5,
    width: 50.3,
    height: 83,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_2_",
    className: "st2",
    d: "M3.2,98.9L0,14.3C-0.1,11.5,2,9.2,4.8,9l71.9-4.5c2.8-0.2,5.3,2,5.5,4.8c0,0.1,0,0.2,0,0.3 v92.1c0,2.8-2.3,5.1-5.1,5.1c-0.1,0-0.2,0-0.2,0l-68.7-3.1C5.4,103.7,3.3,101.5,3.2,98.9L3.2,98.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.7,17.1l0.5-11.8l9.9-0.8l0.4,12.2c0,0.4-0.3,0.8-0.7,0.8c-0.2,0-0.4-0.1-0.5-0.2l-3.8-3l-4.5,3.4 c-0.3,0.3-0.8,0.2-1.1-0.1C60.7,17.4,60.7,17.3,60.7,17.1z M48.1,43.1c0,2,13.5,1,15.3-0.4c0-13.6-7.3-20.8-20.7-20.8 s-20.9,7.3-20.9,18.2c0,19,25.7,19.4,25.7,29.8c0,2.9-1.4,4.6-4.6,4.6c-4.1,0-5.7-2.1-5.5-9.2c0-1.5-15.6-2-16.1,0 C20,82.5,30.8,87.5,43,87.5c11.9,0,21.2-6.3,21.2-17.8c0-20.4-26-19.8-26-29.9c0-4.1,3-4.6,4.8-4.6C44.9,35.1,48.3,35.5,48.1,43.1 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorybook);
export default __webpack_public_path__ + "static/media/storybook.4d16fda6733ae2c6c7393b97260c82b0.svg";
export { ForwardRef as ReactComponent };